import React from "react";

import { IconButton, IconButtonProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { GreyLight, GreyMedium } from "assets/colors";

export interface ISmallIconButton extends IconButtonProps {
  filled?: boolean;
}

const useStyles = makeStyles({
  SmallIconButton: (props: ISmallIconButton) => ({
    padding: "8px",
    color: "inherit",
    "&:hover": {
      backgroundColor: GreyLight,
    },
    ...(props.filled && {
      "&.Mui-disabled": {
        backgroundColor: GreyLight,
      },
    }),
    ...(props.filled && {
      backgroundColor: GreyLight,
      "&:hover": {
        backgroundColor: GreyMedium,
      },
    }),
  }),
});

export const SmallIconButton = React.forwardRef<
  HTMLButtonElement,
  ISmallIconButton
>((props, ref) => {
  const classes = useStyles(props);
  const { children, filled, ...iconButtonProps } = props;
  return (
    <IconButton
      className={classes.SmallIconButton}
      {...iconButtonProps}
      ref={ref}
      size="large"
    >
      {children}
    </IconButton>
  );
});

export default SmallIconButton;
